import * as t from 'io-ts';
import {isString} from 'lodash';
import uuid from 'uuid-random';

import {enforceType} from '../../../../libs/shared/helpers/src/typescript/typeHelpers';

/*
 * Navigation blocking.
 */

interface NavigationBlockerIdBrand {
  readonly NavigationBlockerId: unique symbol;
}

export const RNavigationBlockerId = t.brand(
  t.string,
  (id): id is t.Branded<string, NavigationBlockerIdBrand> => isString(id) && uuid.test(id),
  'NavigationBlockerId',
);

export type NavigationBlockerId = t.TypeOf<typeof RNavigationBlockerId>;

export function generateNavigationBlockerId() {
  return enforceType(RNavigationBlockerId, uuid());
}
